import { connect } from 'react-redux'
import { actions } from '@bt-react/store'
import get from 'lodash/get'
import NoAttachments from './NoAttachments'

const mapStateToProps = (state: any, props: any) => {

    const { channelId, webcastId } = props
    const webcast = state.webcast.collection[`${channelId}${webcastId}`]

    return {
        webcastData: webcast && get(webcast, 'status.hasData') && webcast.data
    }

}

const mapDispatchToProps = (dispatch: any) => ({
    setView: (view: string) =>
        dispatch(actions.resource.setAttachmentView(view))
})

export default connect(mapStateToProps, mapDispatchToProps)(NoAttachments)